import type { SwapsTranslations } from "../interfaces/swaps";

export const swapsTranslations: SwapsTranslations = {
  swap_title: "Intercambio de Monedas",
  page_subtitle: "Convierte saldo entre tus billeteras al instante, sin destinatario externo.",

  origin_label: "Moneda Origen",
  destination_label: "Moneda Destino",
  select_origin: "Selecciona moneda origen",
  select_destination: "Selecciona moneda destino",

  amount_origin_label: "Monto Origen",
  amount_destination_label: "Monto Destino",

  quote_breakdown: "Desglose de Cotización",
  conversion_rate: "Tasa de Conversión",
  you_send: "Envías",
  you_receive: "Recibes",
  fees: "Comisión",
  recalculate_quote: "Recalcular cotización",

  quote_valid_for: "Esta tasa es válida por",
  quote_expiring_soon: "La cotización expirará pronto",
  quote_expired_message: "La cotización ha expirado",

  conversion_fee: "Comisión de conversión",
  converted: "Monto convertido",
  total_debit: "Total a debitar",

  confirm_swap: "Confirmar Swap",
  make_another_swap: "Hacer otro Swap",

  success_title: "¡Swap Exitoso!",
  success_description: "Tu intercambio de monedas se ha completado correctamente",
  previous_balance: "Saldo Anterior",
  current_balance: "Saldo Actual",
  change: "Cambio",

  loading_quote: "Obteniendo cotización...",
  loading_wallets: "Cargando billeteras...",
  retry: "Reintentar",
  error_origin_required: "Selecciona una moneda origen",
  error_destination_required: "Selecciona una moneda destino",
  error_amount_required: "Ingresa un monto válido",
  error_insufficient_balance: "Saldo insuficiente para cubrir el monto y la comisión",
  error_no_quote: "No hay cotización disponible",
  error_swap_failed: "Error al realizar el swap",

  available_balance_label: "Saldo disponible:",
  wallet_not_activated_hint: "(sin activar)",
  wallet_will_be_activated: "Se activará una billetera en esta moneda al confirmar el swap",
  no_wallets_title: "No hay billeteras activas",
  no_wallets_message:
    "No tienes billeteras activas. Activa una desde la sección de Billeteras para poder intercambiar monedas.",
  convert_title: "Convertir",
  convert_subtitle: "Entre tus billeteras",
  convert_from: "Desde",
  convert_to: "Hacia",
  convert_wallet: "Billetera {{currency}}",
  convert_available: "Disponible {{amount}}",
  convert_balance: "Saldo {{amount}}",
  convert_flip: "Invertir billeteras",
  convert_frozen: "Congelada",
  convert_send_label: "Conviertes",
  convert_receive_label: "Recibes",
  convert_rate: "Tipo de cambio",
  convert_valid_for: "Precio válido por {{time}}",
  convert_row_fee: "Comisión",
  convert_row_debit: "Sale de tu billetera",
  convert_row_credit: "Llega a tu billetera",
  convert_fee_free: "Sin comisión",
  convert_insufficient: "No te alcanza: tienes {{balance}} y esta conversión necesita {{debit}}.",
  convert_quote_error: "No pudimos calcular la conversión. Inténtalo de nuevo.",
  convert_pair_unavailable:
    "No podemos cotizar {{from}} a {{to}} en este momento. Inténtalo en unos minutos.",
  convert_retry: "Reintentar",
  convert_send_tip_title: "¿Vas a enviar este dinero a otra persona?",
  convert_send_tip_body: "Hazlo desde Enviar: convertimos dentro del envío y te sale más barato.",
  convert_send_tip_action: "Ir a Enviar",
  convert_review: "Revisar conversión",
  convert_cancel: "Cancelar",
  convert_close: "Cerrar",
  convert_review_title: "Revisa y convierte",
  convert_review_leaves: "Sale de tu billetera {{currency}}",
  convert_review_lands: "Llega a tu billetera {{currency}}",
  convert_review_irreversible: "La conversión es inmediata y no se puede deshacer.",
  convert_review_edit: "Editar",
  convert_confirm: "Convertir {{amount}}",
  convert_review_changed: "El precio cambió mientras revisabas. Revisa los valores antes de convertir.",
  convert_processing: "Convirtiendo tus {{from}} a {{to}}…",
  convert_processing_hint: "Toma solo unos segundos.",
  convert_transit_aria: "Convirtiendo {{debit}} de tu billetera {{from}} a {{credit}} en tu billetera {{to}}",
  convert_success_title: "Convertiste {{amount}}",
  convert_success_rate: "Al tipo de cambio {{rate}}",
  convert_success_landed: "Llegó a tu billetera {{currency}}",
  convert_balance_now: "Saldo ahora",
  convert_again: "Convertir de nuevo",
  convert_view_movements: "Ver movimientos",
  convert_done: "Listo",
  convert_error_title: "No se pudo convertir",
  convert_error_generic: "No pudimos hacer la conversión. Nada se movió de tus billeteras.",
  convert_error_consumed:
    "La conversión puede haberse hecho aunque no recibimos la respuesta. Revisa los movimientos de la billetera antes de intentarlo de nuevo.",
  convert_error_back: "Volver",
  convert_read_only:
    "Puedes ver estas billeteras, pero tu usuario no tiene permiso para convertir. Pídeselo a un administrador de tu organización.",
};
